import React from "react";
import styled from "@emotion/styled";
import { GameCircle } from "./GameCircle";
import { StoreButton } from "../../StoreButton";

import playStoreLogo from "../../../images/play-store.png";
import appStoreLogo from "../../../images/app-store.png";
import { SMALL_DEVICES } from "../../../mediaQueries";

const Container = styled.div`
  display: flex;
  margin-top: 10px;
  padding: 20px;

  ${SMALL_DEVICES} {
    flex-direction: column;
    align-items: center;
    padding: 5px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

const Title = styled.div`
  font-size: 30px;
  color: white;
  font-weight: bold;
  margin-bottom: 10px;
`;

const Description = styled.div`
  font-size: 24px;
  color: white;
  font-weight: lighter;
  margin-bottom: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
`;

const StoreButtonSpacing = styled.div`
  margin-right: 20px;
`;

interface Props {
  title: string;
  description: string;
  image: string;
  appStoreUrl: string;
  googlePlayStoreUrl: string;
}

export const GameItem: React.FC<Props> = (props) => {
  return (
    <Container>
      <GameCircle image={props.image} />
      <ContentContainer>
        <Title>{props.title}</Title>
        <Description>{props.description}</Description>
        <ButtonsContainer>
          <StoreButton storeName={"Play Store"} storeLogo={playStoreLogo} url={props.googlePlayStoreUrl} />
          <StoreButtonSpacing />
          <StoreButton
            isInverted
            storeName={"App Store"}
            storeLogo={appStoreLogo}
            url={props.appStoreUrl}
          />
        </ButtonsContainer>
      </ContentContainer>
    </Container>
  );
};
